import { useEffect, useRef } from 'react'

// 获取从R1_APP传过来的消息
const useGetMessageFromR1App = <T extends keyof ReciveActions>(action: T) => {
  const reciveMessage = useRef<ReciveActions[T]>()

  useEffect(() => {
    const handleEvent = (message: { data: TSendMsg<T> }) => {
      console.log(message)
      if (message.data.action === action) {
        reciveMessage.current = message.data.extra
      }
    }
    ;(document as any).addEventListener('message', handleEvent, false)

    return () => (document as any).removeEventListener('message', handleEvent, false)
  }, [])

  return reciveMessage.current
}

export enum PayStatus {
  Success = 1,
  Fail,
}
/** H5接收RN消息 */
export type TSendMsg<T extends keyof ReciveActions> = {
  version: string // App版本号
  from: string
  action: T
  extra?: ReciveActions[T]
}
export type ReciveActions = {
  PayResult: {
    orderCode: string
    status: PayStatus
    msg?: string
  }
}

export default useGetMessageFromR1App
